import { Tooltip } from '@chakra-ui/react';
import { IColumn } from '../types';
import { defaultHeaderRenderer } from '../headers';
import { CellEventsHandler } from '../formatters';
import { CellProps } from '../../types';
import { useState } from 'react';
import { OverflowedText } from '../../../../../utilities/overflowedText';

const LeftAlignFormatter = (cellProps: CellProps) => {
  const [isOverflowed, setIsOverflowed] = useState<boolean>(false);

  const { course } = cellProps.row;
  return (
    <CellEventsHandler cellProps={cellProps}>
      <Tooltip isDisabled={!isOverflowed} hasArrow placement="top" label={cellProps.row.course || ''}>
        <div>
          <OverflowedText
            overflowedHandler={setIsOverflowed}
            theme={{
              lines: 4,
            }}
          >
            {course}
          </OverflowedText>
        </div>
      </Tooltip>
    </CellEventsHandler>
  );
};

export const CourseColumn = (): IColumn => ({
  item: {
    key: 'course',
    name: 'Course',
    headerRenderer: defaultHeaderRenderer,
    sortable: true,
    width: 'minmax(160px, 1.75fr)',
    formatter: LeftAlignFormatter,
    responsive: true,
    events: {
      goToStudentDetail: true,
    },
  },
  visible: () => true,
});
